import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessPage',
  setup(__props) {


const router = useRouter()

const goToHomepage= () => {
  const userStore = useUserStore();
  userStore.fetchUser(true)
  router.push('/home')

};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "card" }, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Success!", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "You have successfully subscribed to our service, Thank you! ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "You are awesome!", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, " Enjoy it, and have a great day!", -1)),
      _createElementVNode("div", { class: "button-container" }, [
        _createElementVNode("button", {
          class: "home-btn",
          onClick: goToHomepage
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("strong", null, " START ", -1)
        ]))
      ])
    ])
  ]))
}
}

})